<template>
    <!--<div class="contactImg">
        <div class="container py-5">
            <div class="row d-flex justify-content-center">
                <div>
                    <div class="row d-flex justify-content-center">
                        <div class="col-9 text-center ajuste-textos animate__animated animate__fadeInLeft py-4">
                            <h1 class="textos subtitulos-intermedios bold blanco">
                                <span class="textos subtitulos-intermedios bold rojo">AQUÍ COMIENZA TU</span> TRANQUILIDAD
                            </h1><p class="textos parrafos-principales light blanco">Ingresa tus datos y un asesor te contactará pronto</p>
                        </div>
                    </div>
                </div>
                <div class="row d-flex justify-content-center col-12">
                    <div class="col-md-10 p-4 p-md-0">
                        <div class="row d-flex justify-content-center">
                            <div class="col-12 bordes-form">

                                <input type="text"
                                       placeholder="NOMBRE"
                                       autocomplete="off"
                                       name="nombre" id="nombre"
                                       v-model="nombre"
                                       maxlength="200"
                                       @keypress="validarRegex($event, 'LE')" />
                            </div>
                            <div class="col-12 bordes-form">


                                <input type="email"
                                       placeholder="CORREO"
                                       autocomplete="off"
                                       v-model="correo"
                                       @keypress="validarRegex($event, 'EMAIL')" />
                            </div>
                            <div class="col-12 col-md-5 bordes-form">

                                <input type="text"
                                       placeholder="EMPRESA"
                                       name="empresa"
                                       id="empresa"
                                       autocomplete="off"
                                       v-model="empresa"
                                       maxlength="200"
                                       @keypress="validarRegex($event, 'NL')" />
                            </div>
                            <div class="col-12 offset-md-1 col-md-6 bordes-form ">

                                <input type="text"
                                       pattern="[0-9]+"
                                       maxLength="15"
                                       placeholder="TELÉFONO"
                                       autocomplete="off"
                                       v-model="telefono"
                                       @keypress="validarRegex($event, 'N')" />
                            </div>
                            <div class="col-12 p-0">
                                <textarea placeholder="MENSAJE"
                                          class="border border-white"
                                          id="mensaje"
                                          cols="1"
                                          rows="3"
                                          name="mensaje"
                                          autocomplete="off"
                                          maxLength="500"
                                          v-model="mensaje"></textarea>
                            </div>
                            <div class="col-12 p-0 text-center py-4 animate__animated animate__pulse animate__infinite	infinite">
                                :disabled="botond"
                                <button class="bg-amarillo textos parrafos-principales negro semi-bold px-4 py-2 rounded-pill"
                                        @click="Validar()">
                                    ENVIAR
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>-->
    <section id="section-contacto" class="contactImg">
        <div class="container py-md-5">


            <div id="section-contacto" class="contenedor">
                <!-- <form id="formulario"> -->
                    <div>
                        <div class="row d-flex justify-content-center">
                            <div class="col-9 text-center ajuste-textos animate__animated animate__fadeInLeft py-4">
                                <h1 class="textos subtitulos-intermedios bold blanco">
                                    <span class="textos subtitulos-intermedios bold rojo">AQUÍ COMIENZA TU</span>
                                    TRANQUILIDAD
                                </h1>
                                <p class="textos parrafos-principales light blanco">
                                    Ingresa tus datos y un asesor te contactará pronto
                                </p>
                            </div>
                        </div>
                        <div class="row d-flex justify-content-center col-12">
                            <div class="col-md-10 p-4 p-md-0">
                                <div class="row d-flex justify-content-center">
                                    <div class="col-12 bordes-form">

                                        <input type="text"
                                               placeholder="NOMBRE"
                                               autocomplete="off"
                                               name="nombre" id="nombre"
                                               v-model="nombre"
                                               maxlength="200"
                                               @keypress="validarRegex($event, 'LE')" />
                                    </div>
                                    <div class="col-12 bordes-form">


                                        <input type="email"
                                               placeholder="CORREO"
                                               autocomplete="off"
                                               v-model="correo"
                                               @keypress="validarRegex($event, 'EMAIL')" />
                                    </div>
                                    <div class="col-12 col-md-5 bordes-form">

                                        <input type="text"
                                               placeholder="EMPRESA"
                                               name="empresa"
                                               id="empresa"
                                               autocomplete="off"
                                               v-model="empresa"
                                               maxlength="200"
                                               @keypress="validarRegex($event, 'NL')" />
                                    </div>
                                    <div class="col-12 offset-md-1 col-md-6 bordes-form ">

                                        <input type="text"
                                               pattern="[0-9]+"
                                               maxLength="15"
                                               placeholder="TELÉFONO"
                                               autocomplete="off"
                                               v-model="telefono"
                                               @keypress="validarRegex($event, 'N')" />
                                    </div>
                                    <div class="col-12 p-0">
                                        <textarea placeholder="MENSAJE"
                                                  class="border border-white"
                                                  id="mensaje"
                                                  cols="1"
                                                  rows="3"
                                                  name="mensaje"
                                                  autocomplete="off"
                                                  maxLength="500"
                                                  v-model="mensaje"></textarea>
                                    </div>
                                     <div class="col-12 p-0 text-center py-4 animate__animated animate__pulse animate__infinite	infinite">
                                    <button type="button" @click="Validar()" class="btn btn-warning btn-lg" v-if="!botond">ENVIAR</button>
                                     <button  v-if="botond" class="btn btn-warning btn-lg " type="button" >
                                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                           ENVIAR
                                            </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex justify-content-center">
                        <div class="col-md-12 p-4 p-md-0 text-center"></div>
                    </div>
                <!-- </form> -->
            </div>
        </div>
    </section>
</template>
<style>


    @import "../assets/template/css/HomaMedia.css";
    @import "../assets/template/css/textosF.css";
    @import "../assets/template/css/generals.css";
    @import "../assets/contact/ContenidoServices.css";
    @import "../assets/template/css/textosF.css";
    @import "../assets/template/css/generals.css";

    .locImg {
        background-image: url("../assets/contact/location.png");
    }

    .msjImg {
        background-image: url("../assets/contact/mensaje.png");
    }

    .telImg {
        background-image: url("../assets/contact/telefono.png");
    }

    .contactImg {
        background-image: url("../assets/contact/fondoCon.png");
    }


    #section-banner-contacto {
        min-height: 650px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(../assets/contact/bannerCon.png);
    }

        #section-banner-contacto .ajuste-textos {
            padding-top: 180px;
        }

    @media (max-width: 540px) {
        .imgContac {
            min-height: 550px;
            background-image: url("../assets/contact/banner_mobile.png");
        }
    }

    @media (min-width: 541px) {
        .imgContac {
            min-height: 650px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url("../assets/contact/bannerCon.png");
        }
    }
</style>
<script>
    import Axios from "axios";
      import {mapActions, mapState} from 'vuex'
    export default {
        data() {
            return {
                nombre: "",
                correo: "",
                empresa: "",
                telefono: "",
                mensaje: "",
                botond: false
            }
        },
         computed: {
            ...mapState(['domain']),
        },
        methods: {

            Validar() {
                this.botond = true;

                if ((this.nombre != "" && this.nombre.length > 4)
                    && (this.telefono != "" && this.telefono.length >= 10) &&
                    (this.correo != "" && this.validarRegex(this.correo, 'EMAIL'))
                    && this.empresa != "" && this.mensaje != "") {
                    this.Enviar();
                }
                else {
                    let nom = this.nombre == "" || this.nombre.length <=4 ? "Escriba su nombre</br>" : "";
                    let Tel = this.telefono == "" || this.telefono.length < 10 ? "Escriba un número de teléfono</br>" : "";
                    let cor = this.correo == "" || !this.validarRegex(this.correo, 'EMAIL') ? "Escriba un correo valido</br>" : "";
                    let emp = this.empresa == "" ? "Escriba su empresa</br>" : "";
                    let sms = this.mensaje == "" ? "Escriba su mensaje</br>" : "";

                    var mensaje = `${nom}
                            ${Tel}
                            ${cor}
                            ${emp}
                            ${sms}
                            `;
                    this.botond = false;
                    this.$swal({
                        icon: 'info',
                        type: 'error',
                        title: 'Favor de verificar lo siguiente:',
                        html: mensaje,
                    })
                }

    },
    Enviar(){
        var formData = {nombre:this.nombre ,email: this.correo,
        empresa: this.empresa,telefono: this.telefono,mensaje: this.mensaje}
        var raw = JSON.stringify(formData);
        var formData2 = new FormData();
         formData2.append("datos", raw);
        Axios.post(`${this.domain.domainNameForApi}/Contacto/contactoPar`,
            formData2).then(response => {
             if (response.data.success){
                this.resetForm();
                this.$swal({
                        icon: 'success',
                        type: 'success',
                        title: '¡GRACIAS!',
                        html: 'PRONTO TE CONTACTAREMOS',
                    })
            }else {
                 this.$swal({
                            icon: 'error',
                            type: 'error',
                            title: 'ERROR',
                            html: 'INTENTE NUEVAMENTE',
                        })
            }
        })
            }, resetForm() {
                this.nombre = "";
                this.correo = "";
                this.empresa = "";
                this.telefono = "";
                this.mensaje = "";
                this.botond = false;
            },
            validarRegex(evt, tipo) {
                //Ejemplo JS Input onkeypress="javascript:return validarRegex(event, 'L')"
                //Ejemplo Vue Input @keypress="validarRegex($event, 'N')"
                //Referencia expresiones regulares https://www.sitepoint.com/expressions-javascript/
                //ND-Solo Números con Decimales  N-Sólo Números  L-Sólo Letras NL-Sólo Letras y Números NCS-Número Cuenta Servicio LE-Letras con espacios  ND2-Número con 2 decimales NM-Moneda(1, 1.0, 1.01)
                //NMD-Moneda con decimales libres  LV = Solo Letras asignando una variable NV = Solo Numeros asignando una variable NLV = Solo Numeros y Letras asignando una variable
                //NMDV-Moneda con decimales libres asignando una variable UUID-Facturas NG | Sólo números y guiones  LNE | Solo letras, numeros y espacios; NDN | Números decimales negativos;
                //NDNV | Números Decimales Negativos asignando una variable; NMNP | Número Moneda para Positivos y Negativos; NMN | Número Moneda para Negativos; CSDEV | Caracteres Sin Dobles Espacios Intermedios asignando una variable;
                //EMAIL-Email en input con separación de comas
                if (tipo == 'L') {
                    var pattern = /^[A-Za-z]+$/;
                    return pattern.test(evt.key) ? pattern.test(evt.key) : evt.preventDefault();
                }

                if (tipo == 'N') {
                    var pattern = /^\d+$/;
                    return pattern.test(evt.key) ? pattern.test(evt.key) : evt.preventDefault();
                }

                if (tipo == 'LE') {
                    var pattern = /^[a-zA-Z\s]*$/;
                    return pattern.test(evt.key) ? pattern.test(evt.key) : evt.preventDefault();
                }

                if (tipo == 'NL') {
                    var pattern = /^\w+$/;
                    return pattern.test(evt.key) ? pattern.test(evt.key) : evt.preventDefault();
                }

                if (tipo == 'NM') {
                    var pattern = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/;
                    return evt.match(pattern) != null ? false : true;
                }

                if (tipo == 'NMD') {
                    var pattern = /^\s*(?=.*[1-9])\d*(?:\.\d{1,9})?\s*$/;
                    return evt.match(pattern) != null ? false : true;
                }

                if (tipo == 'NMDB') {
                    return /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/.test(evt) ? false : true;
                }
                if (tipo == 'EMAIL') {
                    var pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                    return evt.match(pattern) == null ? false : true;
                }
            }
        }
    };
</script>


